import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractAddendum } from '../../../models/Entities/Contracts/ContractAddendum';
import { StageCycle } from '../../../models/Entities/Contracts/StageCycle';

export default function ContractStageCyclesReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  let CurrentContract: Contract | undefined;

  switch (a.type) {
    case 'CONTRACTSTAGECYCLE_ADD_REQUEST_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.newContractStageCycle.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.newContractStageCycle.contractAddendumId);
        if (CurrentAddendum) {
          const UpdatedAddendum = {
            ...CurrentAddendum,
            isSaving: true,
            isSavedSuccessfully: false,
            failOnSaving: false,
            error: undefined,
          } as ContractAddendum;

          CurrentContract.addendums = [
            ...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== UpdatedAddendum.id),
            UpdatedAddendum,
          ];
        }
      }
      return {
        ...currentState,
        list: CurrentContract
          ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract]
          : currentState.list,
      };
    }
    // Cycles by contract (CRUD and bulk)
    case 'CONTRACTSTAGECYCLE_ADD_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractStageCycle.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractStageCycle.contractAddendumId);
        if (CurrentAddendum) {
          const UpdatedAddendum = {
            ...CurrentAddendum,
            cycles: [...(CurrentAddendum.cycles || []).filter((cycle: StageCycle) => cycle.id !== a.contractStageCycle.id), a.contractStageCycle],
            isSaving: false,
            isSavedSuccessfully: true,
            failOnSaving: false,
            error: undefined,
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), UpdatedAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGECYCLE_ADD_FAIL_ACTION': {
      const UpdatedContracts = (currentState.list || []).map((contract: Contract) => {
        const UpdatedAddendums = (contract.addendums || []).map((addendum: ContractAddendum) => {
          if (!addendum.isSaving) return addendum;

          return {
            ...addendum,
            isSaving: false,
            isSavedSuccessfully: false,
            failOnSaving: true,
            error: a.error,
          } as ContractAddendum;
        });

        return {
          ...contract,
          addendums: UpdatedAddendums,
        } as Contract;
      });

      return {
        ...currentState,
        list: UpdatedContracts,
        error: a.error,
      };
    }
    case 'CONTRACTSTAGECYCLE_UPDATE_REQUEST_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractStageCycle.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractStageCycle.contractAddendumId);
        if (CurrentAddendum) {
          let currentCycle = CurrentAddendum.cycles?.find((item: StageCycle) => item.id === a.contractStageCycle.id);
          if (currentCycle) {
            currentCycle = {
              ...currentCycle,
              isUpdating: true,
              isUpdatedSuccessfully: undefined,
              failOnUpdating: false,
              errorOnUpdating: undefined,
            } as StageCycle;
            CurrentAddendum.cycles = [...(CurrentAddendum.cycles || []).filter((cycle: StageCycle) => cycle.id !== (currentCycle as StageCycle).id), currentCycle as StageCycle];
          }
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGECYCLE_UPDATE_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractStageCycle.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractStageCycle.contractAddendumId);
        if (CurrentAddendum) {
          let currentCycle = CurrentAddendum.cycles?.find((item: StageCycle) => item.id === a.contractStageCycle.id);
          if (currentCycle) {
            currentCycle = {
              ...currentCycle,
              ...a.contractStageCycle,
              isUpdating: false,
              isUpdatedSuccessfully: true,
              failOnUpdating: false,
              errorOnUpdating: undefined,
            } as StageCycle;
            CurrentAddendum.cycles = [...(CurrentAddendum.cycles || []).filter((cycle: StageCycle) => cycle.id !== (currentCycle as StageCycle).id), currentCycle as StageCycle];
          }
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGECYCLE_DELETE_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
        if (CurrentAddendum) {
          CurrentAddendum.cycles = (CurrentAddendum.cycles || []).filter((item: StageCycle) => item.id !== a.contractStageCycleId);
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGECYCLE_GET_ALL_BY_CONTRACTID_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), { ...contract, cycles: a.contractStageCycles as StageCycle[] }] : currentState.list,
      };
    }
    case 'CONTRACTSTAGECYCLE_UPDATE_ALL_BY_CONTRACTID_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), { ...contract, cycles: a.contractStageCycles as StageCycle[] }] : currentState.list,
      };
    }

    // Cycles by addendum (flags + set)
    case 'CONTRACTSTAGECYCLE_GET_ALL_BY_ADDENDUMID_REQUEST_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractCycles: true,
            isGettingContractCyclesSuccess: false,
            FailGettingContractCycles: false,
            ErrorGettingContractCycles: undefined,
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGECYCLE_GET_ALL_BY_ADDENDUMID_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractCycles: false,
            isGettingContractCyclesSuccess: true,
            FailGettingContractCycles: false,
            ErrorGettingContractCycles: undefined,
            cycles: a.contractStageCycles as StageCycle[],
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGECYCLE_GET_ALL_BY_ADDENDUMID_FAIL_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractCycles: false,
            isGettingContractCyclesSuccess: false,
            FailGettingContractCycles: true,
            ErrorGettingContractCycles: a.error,
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }

    default:
      return currentState;
  }
}
